import * as React from "react";
import * as React44ms from "../../../Util/form-utils/react-44ms";

import { ACountry, Country } from "../../model";

export interface LocalizationConsumerInterface {
  countryCode: Country;
}

const defaultValue = {
  countryCode: ACountry.Australia,
};

const LocalizationContext = React.createContext(
  defaultValue as LocalizationConsumerInterface
);
const LocalizationContext_44 = React44ms.React.createContext(
  defaultValue,
  LocalizationContext
);

interface LocalizationProviderProps {
  children?: React.ReactNode;
}

const getCountryCodeFromDocument = (): Country => {
  let countryCode: Country = defaultValue.countryCode;
  const countrySelectorNode = document.querySelector(
    '[data-block="country-selector"]'
  );
  if (countrySelectorNode) {
    const currentCountryNode = countrySelectorNode.querySelector(
      '[data-js="current-country"]'
    );
    if (currentCountryNode && currentCountryNode instanceof HTMLElement) {
      const currentCountryDataset = currentCountryNode.dataset;
      if (currentCountryDataset) {
        const currentCountryCountryCodeDataValue =
          currentCountryDataset.countryCode;
        if (
          currentCountryCountryCodeDataValue &&
          Object.values<string>(ACountry).includes(
            currentCountryCountryCodeDataValue
          )
        ) {
          countryCode = currentCountryCountryCodeDataValue as Country;
        }
      }
    }
  }

  return countryCode;
};

export const LocalizationProvider: React.FunctionComponent<
  LocalizationProviderProps
> = (props) => {
  const countryCode = React.useMemo(() => {
    return getCountryCodeFromDocument();
  }, []);
  const value: LocalizationConsumerInterface = React.useMemo(
    () => ({
      countryCode,
    }),
    [countryCode]
  );
  return (
    <LocalizationContext.Provider value={value}>
      <LocalizationContext_44.Provider value={value}>
        {props?.children}
      </LocalizationContext_44.Provider>
    </LocalizationContext.Provider>
  );
};

export const useLocalizationProvider = (): LocalizationConsumerInterface =>
  React.useContext(LocalizationContext);

export const useLocalizationProvider_44 = (): LocalizationConsumerInterface =>
  React44ms.React.useContext(LocalizationContext_44);
